import { KidsData } from "modules/profile";
import { useState, useEffect } from "react";
import { getParentBookingCounter } from "services/booking/get-parent-booking-counter";
import { getParentKids } from "services/get-parents-kids";
import styles from "./dashboardSection.module.css";
import { FaArrowRight } from "react-icons/fa6";

interface DashboardSectionProps {
    onBookingDetailsClick: () => void;
    onCancellationDetailsClick: () => void;
}

export default function DashboardSection({
    onBookingDetailsClick,
    onCancellationDetailsClick,
}: DashboardSectionProps) {
    const [bookingCount, setBookingCount] = useState(0);
    const [cancelCount, setCancelCount] = useState(0);

    const fetchData = async () => {
        try {
            const kidsDataRes = await getParentKids();
            if (kidsDataRes.kids && kidsDataRes.kids.length > 0) {
                const kidIds = kidsDataRes.kids.map((kid: KidsData) => kid.id);
                if (kidIds.length > 0) {
                    const kidsBookingsCountData = await getParentBookingCounter(kidIds);
                    setBookingCount(parseInt(kidsBookingsCountData.data.booking_counter, 10) || 0);
                    setCancelCount(parseInt(kidsBookingsCountData.data.cancel_counter, 10) || 0);
                }
            }
        } catch (error) {
            console.error("Fehler beim Laden der Daten:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.leftItem}>
                <h2>Informationen zu Buchungsanfragen</h2>
                <div className={styles.itemComponentRow}>
                    <p className={styles.leftCounter}>{bookingCount}</p>
                    <div className={styles.detailsContainer} onClick={onBookingDetailsClick}>
                        <p>Details</p>
                        <FaArrowRight className={styles.icon} />
                    </div>
                </div>
            </div>
            <div className={styles.rightItem}>
                <h2>Informationen zu Stornierungsanfragen</h2>
                <div className={styles.itemComponentRow}>
                    <p className={styles.rightCounter}>{cancelCount}</p>
                    <div className={styles.detailsContainer} onClick={onCancellationDetailsClick}>
                        <p>Details</p>
                        <FaArrowRight className={styles.icon} />
                    </div>
                </div>
            </div>
            <div className={styles.imageItem}>
                <img src="https://www.studierendenwerk-siegen.de/wp-content/uploads/2022/01/bunte-kinderhaende.jpg"
                    alt="img" className={styles.image} />
            </div>
        </div>
    );
}
